import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { CourtModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useCourtById() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const courtById = async (courtId: number) => {
    setLoading(true)
    try {
      const data = await fetcher<CourtModel>(
        `${CONFIG.BOUNCE_API}/api/v1/management/courts/${courtId}`
      )
      if (data) {
        setError(null)
        return data
      }
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return { courtById, loading, error, resetState }
}
